<template>
  <div>
    <div
      v-for="(setParams, setIndex) in sets"
      :key="'set'+setIndex"
      class="align-center mb-2"
    >
      <div
        class="grey--text text--darken-1 d-inline-block"
        style="width: 50px"
        :class="{ 'caption': dense, 'text-body-1': !dense }"
      >
        {{ $t("training_builder.configure.set", {set: setIndex + 1}) }}:
      </div>

      <exercise-param-label-helper
        :label="$t('reps.label')"
        :dense="dense"
        :param="setParams.NMRP"
      />

      <exercise-param-label-helper
        :label="$t('rep_work.label')"
        :dense="dense"
        :param="setParams.RPWRDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('rep_rest.label')"
        :dense="dense"
        :param="setParams.RPRSDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('rest_after_set.label')"
        :dense="dense"
        :param="setParams.RSSTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('table_headers.performance.player_details.efforts.distance')"
        :dense="dense"
        :param="setParams.DIST"
        suffix="m"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.speed.title')"
        :dense="dense"
        :param="getSpeed(setParams.SPD)"
        :suffix="$t(`suffixes.${getUnitSuffixForUser( 'km/h')}`)"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.num_of_cod.title')"
        :dense="dense"
        :param="setParams.NUMCOD"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.degree_of_cod')"
        :dense="dense"
        :param="setParams.DEGCOD"
        suffix="deg"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.dropdown.terrain.title')"
        :dense="dense"
        :param="setParams.TRRN"
      />
    </div>
  </div>
</template>
<script>

import ExerciseParamLabelHelper from '@/components/training-builder/ExerciseParamLabelHelper.vue'
import { convertSpeedByUnitSystem } from '@/components/training-builder/helpers'
import { getUnitSuffixForUser } from '@/utils/helpers'

export default {
  name: 'SpeedParamsView',
  components: { ExerciseParamLabelHelper },
  props: {
    sets: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    hasRealizations: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    }
  },
  methods: {
    getUnitSuffixForUser,
    getSpeed(param) {
      if (param && typeof param === 'object' && 'def' in param) {
        return {
          def: convertSpeedByUnitSystem(param.def, this.user?.organisation_settings?.unit_system, true),
          real: convertSpeedByUnitSystem(param.real, this.user?.organisation_settings?.unit_system, true)
        }
      }

      if (!param) return null

      return convertSpeedByUnitSystem(param, this.user?.organisation_settings?.unit_system, true)
    }
  }
}
</script>
